
import {  applyMiddleware } from 'redux';
import { legacy_createStore as createStore} from 'redux'
import thunk from 'redux-thunk';
import Reducer from './Reducers/Reducers';

const store = createStore(Reducer, applyMiddleware(thunk));

export default store;